import { EFileType } from '@/constant';
import { GetWorkerUseTipListResponse } from '@/services';

import { formatDate, getImageIdsFromContentEditor, map } from 'utils';

export const formatSystemUseTipDetail = (
	input: GetWorkerUseTipListResponse['content'][number]
) => {
	return {
		...input,
		initialImageIds: getImageIdsFromContentEditor(input.content),
		initialContent: input.content,
		registDt: formatDate(input.registDt),
		updateDt: formatDate(input.updateDt),
		fileList: input?.attachmentList?.map((file) => ({
			...file,
			uid: file.fileId,
			fileType: EFileType.SERVER,
			size: file.fileSize,
		})),
	};
};

export const formatSystemUseTipList = (
	input: GetWorkerUseTipListResponse['content']
) => {
	return map(input, formatSystemUseTipDetail);
};
